import { useRef, useState } from "react";
import { BASE_URL } from "./api";

export default function PracticeCsvImport({ onImported }) {
  const inputRef = useRef(null);
  const [status, setStatus] = useState(null); // null | { ok, created, skipped, errors }
  const [loading, setLoading] = useState(false);

  async function handleFile(e) {
    const file = e.target.files?.[0];
    if (!file) return;
    e.target.value = "";

    setLoading(true);
    setStatus(null);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const token = localStorage.getItem("authToken");
      const res = await fetch(`${BASE_URL}/practices/bulk-csv`, {
        method: "POST",
        headers: { Authorization: `Bearer ${token}` },
        body: fd,
      });
      const payload = await res.json().catch(() => ({}));
      if (!res.ok) {
        setStatus({ ok: false, message: payload?.error || "Upload failed" });
        return;
      }
      setStatus(payload);
      if (payload.created > 0) onImported?.();
    } catch (err) {
      setStatus({ ok: false, message: err.message || "Upload failed" });
    } finally {
      setLoading(false);
    }
  }

  return (
    <div>
      <input
        ref={inputRef}
        type="file"
        accept=".csv,text/csv"
        style={{ display: "none" }}
        onChange={handleFile}
      />
      <button
        className="btn ghost small"
        onClick={() => inputRef.current?.click()}
        disabled={loading}
        title="Import practices from CSV"
      >
        {loading ? "Importing…" : "Import CSV"}
      </button>

      {status && (
        <div
          className="help"
          style={{
            marginTop: 6,
            color: status.ok === false ? "red" : status.skipped > 0 ? "#b45309" : "green",
          }}
        >
          {status.ok === false
            ? status.message
            : `Imported ${status.created} practice${status.created !== 1 ? "s" : ""}${status.skipped > 0 ? `, ${status.skipped} skipped` : ""}.`}
          {status.errors?.length > 0 && (
            <ul style={{ margin: "4px 0 0", paddingLeft: 16 }}>
              {status.errors.map((e, i) => <li key={i}>{e}</li>)}
            </ul>
          )}
        </div>
      )}

    </div>
  );
}
